export class SessionExpiredException extends Error {
    constructor(message: string) {
        super();
        this.name = 'SessionExpiredException';
        this.message = message;
    }
}

export class InternalServiceException extends Error {
    constructor(message: string) {
        super();
        this.name = 'InternalServiceException';
        this.message = message;
    }
}
